export const camera = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9.16795 3.9453L10 3.5H18L18.8321 3.9453L20.5352 6.5H25L26 7.5V22.5L25 23.5H3L2 22.5V7.5L3 6.5H7.46482L9.16795 3.9453ZM10.5352 5.5L8.83205 8.0547L8 8.5H4V21.5H24V8.5H20L19.1679 8.0547L17.4648 5.5H10.5352ZM14 11C12.067 11 10.5 12.567 10.5 14.5C10.5 16.433 12.067 18 14 18C15.933 18 17.5 16.433 17.5 14.5C17.5 12.567 15.933 11 14 11ZM8.5 14.5C8.5 11.4624 10.9624 9 14 9C17.0376 9 19.5 11.4624 19.5 14.5C19.5 17.5376 17.0376 20 14 20C10.9624 20 8.5 17.5376 8.5 14.5ZM21.5 12.25C22.1904 12.25 22.75 11.6904 22.75 11C22.75 10.3096 22.1904 9.75 21.5 9.75C20.8096 9.75 20.25 10.3096 20.25 11C20.25 11.6904 20.8096 12.25 21.5 12.25Z"
    fill="currentColor"
  />
);
